import Send from"@/Send.js";

// 수입사 데이터 인사이트 — 신규 API 9종.
// 명세: MKB-PLAN/DEV-6/마켓뱅-데이터-인사이트-개발명세서-확정본.md
//
// · 인증은 Send.js 의 withCredentials(세션 쿠키)로 처리되므로 여기서 붙일 헤더가 없다.
// · 금액 필드는 서버가 이미 부가세 포함가로 내려준다 — 화면에서 추가 환산하지 않는다.
// · 신선도: kpi 의 미처리/재고 부분과 pending-orders·stock-alerts 는 실시간, 나머지는 전일 배치(§3.1).
//
// 파라미터 계약(백엔드 enum 과 1:1):
//   mode   = WEEK | MONTH | QUARTER | CUSTOM (CUSTOM 일 때만 startDate/endDate)
//   metric = AMOUNT | BUYERS | PER_BUYER
//   sort   = AMOUNT | QTY (베스트셀러) / AMOUNT | COUNT (Top 거래처)
//   filter = ALL | OUT | LOW | NO_RESTOCK

// 인사이트는 단독 페이지라 수입사(seller)와 관리자(admin) 양쪽에서 같은 화면을 연다.
// 관리자는 ?companyNo=N 을 달고 들어오며, 이때만 admin 통계 API 로 붙고 조회 대상을 명시한다.
// 파라미터가 없으면 seller API — 조회 스코프를 서버가 세션의 COMPANY_NO 로 강제 필터한다(§2.2).
const query = new URLSearchParams(window.location.search);
const admin_company_no = query.get("companyNo");
const BASE_URL = admin_company_no ? "/api/admin/v1/stat/company/insight" : "/api/seller/v1/insight";
const SCOPE_PARAMS = admin_company_no ? {"companyNo": admin_company_no} : {};

// 화면(Insight.vue)도 같은 판별이 필요하다 — 회사명 출처와 드릴다운 노출이 진입 경로에 따라 갈린다.
// URL 을 두 곳에서 각자 파싱하면 어긋나므로 여기서 한 번만 읽어 내보낸다.
export const is_admin_mode = !!admin_company_no;
// 관리자 진입 시 어드민이 회사명을 URL 로 넘겨준다. kpi 응답의 companyName 이 정본이고
// 이 값은 응답 도착 전 첫 렌더용 초기 표기다(관리자용 회사명 단독 조회 API 는 없다).
export const admin_company_name = admin_company_no ? (query.get("companyName") || "") : "";

function get(path, params){
	return Send({"method": "get", "url": `${BASE_URL}${path}`, "params": {...SCOPE_PARAMS, ...params}});
}

// UI 는 탭 key 를 소문자로 들고 있고(TabPeriod 기본값), 서버 enum 은 대문자다.
function period_params( period ){
	const mode = String(period.mode || "").toUpperCase();
	const params = {"mode": mode};
	if(mode === "CUSTOM"){
		params.startDate = period.start;
		params.endDate = period.end;
	}
	return params;
}

export default {
	// 핵심 지표 4카드 — 발주액 / 활성거래처 / 미처리주문 / 재고경보 (§6.1)
	getKpi( period ){
		return get("/kpi", period_params( period ));
	},

	// 발주액 추이 — 라인 + 작년 동기(YoY) 비교 (§6.2)
	getSalesTrend( period ){
		return get("/sales-trend", period_params( period ));
	},

	// 시장 포지션 — 자사 vs 마켓 1위(익명). metric 별로 개별 요청 (§6.3)
	getMarketPosition(period, metric){
		return get("/market-position", {...period_params( period ), "metric": metric});
	},

	// 거래처 활성화 — 신규/재발주 추이 + 재발주 비중 (§6.4). mode 에 WEEK 없음
	getCorrespondentActivation( period ){
		return get("/correspondent-activation", period_params( period ));
	},

	// 채널 믹스 — 업종별 발주액 비중 (§6.5). 거래처 활성화 토글의 '최근 구간'을 따른다
	getChannelMix( period ){
		return get("/channel-mix", period_params( period ));
	},

	// 베스트셀러 Top5 (§6.6)
	getBestSellers(period, sort){
		return get("/best-sellers", {...period_params( period ), "sort": sort});
	},

	// Top 거래처 Top5 (§6.6)
	getTopCorrespondents(period, sort){
		return get("/top-correspondents", {...period_params( period ), "sort": sort});
	},

	// 미처리 주문 + 반품 접수 통합 목록 (실시간, 최대 10건 · §6.7)
	getPendingOrders(){
		return get("/pending-orders");
	},

	// 재고 경보 목록 (실시간, 최대 10건 · §6.7)
	getStockAlerts( filter ){
		return get("/stock-alerts", {"filter": filter});
	},
};
